import './assets/style.css';
import './assets/public.css';
import './assets/fonts/font.css';
import {JalaliLocaleListener} from "antd-jalali";

import {ConfigProvider} from 'antd';
import faIR from 'antd/locale/fa_IR';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import App from './App';
import store from './components/store/Store';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<ConfigProvider direction='rtl' locale={faIR}>
        <Provider store={store}>
            <BrowserRouter>
                <JalaliLocaleListener/>
                <App/>
            </BrowserRouter>
        </Provider>
    </ConfigProvider>

    ,);
